import { Pfeil } from "./Textwerk";

/*
  Die Werkzeugleiste über dem Blatt.

  Dieselben Klassen wie im Textdokument und auf der Folienbühne — wer eines
  der drei bedient hat, findet sich in den anderen zurecht. Anders als bei
  Quill gibt es hier nichts zu formatieren: Eine Tabelle kennt kein Fett,
  sie kennt Zeilen, Spalten und Zahlen.

  Die Knöpfe tragen Wörter statt Zeichen. „Zeile einfügen" ist mit keinem
  Sinnbild zu treffen, das jeder auf Anhieb versteht, und Platz ist da.
*/

export default function Tabellenleiste({
  bezug,
  kannZurueck,
  kannVor,
  rueckgaengig,
  hatKopie,
  aufZeileEinfuegen,
  aufSpalteEinfuegen,
  aufKopieren,
  aufEinsetzen,
  aufKommentar,
  kannKommentieren,
  aufDrucken,
  aufCsvAus,
  aufCsvEin,
}) {
  return (
    <div className="werkzeugleiste nicht-drucken">
      <div className="werkzeugleiste__eigen">
        <button
          className="wkz"
          title="Rückgängig (Strg+Z)"
          aria-label="Rückgängig"
          disabled={!kannZurueck}
          onClick={() => rueckgaengig && rueckgaengig.undo()}
        >
          <Pfeil richtung="zurueck" />
        </button>
        <button
          className="wkz"
          title="Wiederholen (Strg+Umschalt+Z)"
          aria-label="Wiederholen"
          disabled={!kannVor}
          onClick={() => rueckgaengig && rueckgaengig.redo()}
        >
          <Pfeil richtung="vor" />
        </button>

        <span className="werkzeugleiste__trenner" />

        <button
          className="wkz wkz--wort"
          onClick={aufZeileEinfuegen}
          title="Eine Zeile über der gewählten einfügen"
        >
          Zeile
        </button>
        <button
          className="wkz wkz--wort"
          onClick={aufSpalteEinfuegen}
          title="Eine Spalte links von der gewählten einfügen"
        >
          Spalte
        </button>

        <span className="werkzeugleiste__trenner" />

        <button
          className="wkz wkz--wort"
          onClick={aufKopieren}
          title={`Zelle ${bezug} kopieren (Strg+C)`}
        >
          Kopieren
        </button>
        <button
          className="wkz wkz--wort"
          onClick={aufEinsetzen}
          disabled={!hatKopie}
          title="Kopierte Zelle hier einsetzen (Strg+V) — Bezüge wandern mit"
        >
          Einsetzen
        </button>

        <span className="werkzeugleiste__trenner" />

        <button
          className="wkz wkz--wort"
          onMouseDown={(e) => e.preventDefault()}
          onClick={aufKommentar}
          disabled={!kannKommentieren}
          title={`Kommentar zur Zelle ${bezug}`}
        >
          Kommentar
        </button>

        <span className="werkzeugleiste__trenner" />

        <button className="wkz wkz--wort" onClick={aufDrucken} title="Blatt drucken">
          Drucken
        </button>
        <button
          className="wkz wkz--wort"
          onClick={aufCsvAus}
          title="Als CSV herunterladen — öffnet sich in Excel"
        >
          CSV speichern
        </button>
        <button
          className="wkz wkz--wort"
          onClick={aufCsvEin}
          title="CSV einlesen — ersetzt das ganze Blatt"
        >
          CSV einlesen
        </button>
      </div>
    </div>
  );
}
